import employeeService from '../services/EmployeeService';

export const normaliseTin = (v) => String(v ?? '').replace(/[\s-]/g, '').toUpperCase();

export async function checkTinUnique(tin, currentEmployeeId) {
  const wanted = normaliseTin(tin);
  if (!wanted) return null;

  const res = await employeeService.GetEmployeeList();
  const data = res?.data;
  const list = Array.isArray(data) ? data
    : Array.isArray(data?.ResultSet) ? data.ResultSet
    : Array.isArray(data?.Result) ? data.Result
    : [];

  const self = String(currentEmployeeId ?? '').trim();
  const owner = list.find(
    (e) =>
      normaliseTin(e.HED_TIN_NO) === wanted &&
      (!self || String(e.HED_EMPLOYEE_ID ?? '').trim() !== self)
  );
  if (!owner) return null;

  const who = [owner.HED_SERVICE_NO, owner.HED_REPORT_NAME].filter(Boolean).join(' - ');
  return `TIN No "${String(tin).trim()}" is already used by ${who || 'another employee'}`;
}